(() => {
  // Bridge evidence marker: properties[design_id] is rendered by huina-new-order.liquid.
  const section = document.querySelector('[data-huina-new-order-bridge]');

  if (!section) {
    return;
  }

  const pricing = window.HUINA_HOCKEY_PRICING;
  const packageLabels = {
    jersey: 'Jersey Only',
    'jersey-socks': 'Jersey + Socks',
    'jersey-socks-pant': 'Jersey + Socks + Pant Shell',
  };
  const styleLabels = {
    printed: 'Printed',
    stitched: 'Stitched',
    reversible: 'Reversible',
  };
  const raveStyleLabels = {
    icewolf: 'Icewolf Rave Hockey Jersey',
    owl: 'Owl Rave Hockey Jersey',
    dayofthedead: 'Day of the Dead Rave Hockey Jersey',
    reaper: 'Reaper Rave Hockey Jersey',
    cupid: 'Cupid Rave Hockey Jersey',
    genius: 'Genius Rave Hockey Jersey',
    bluepenguin: 'Blue Penguin Rave Hockey Jersey',
    dotdpro: 'DOTD Pro Rave Hockey Jersey',
    spider: 'Spider Rave Baseball Jersey',
    neongreen: 'Neon Green Rave Baseball Jersey',
    zombie: 'Zombie Rave Baseball Jersey',
    skeleton: 'Skeleton Rave Baseball Jersey',
  };
  const tierRules = [
    { min: 10, max: 49, label: '10-49' },
    { min: 50, max: 149, label: '50-149' },
    { min: 150, max: 299, label: '150-299' },
    { min: 300, max: 499, label: '300-499' },
    { min: 500, max: Infinity, label: '500+' },
  ];
  const minQuantity = Math.max(10, Number(pricing && pricing.minQuantity) || 10);
  const form = section.querySelector('[data-order-form]');
  const quantityInput = section.querySelector('[data-quantity-input]');
  const continueButton = section.querySelector('[data-continue-button]');
  const backButton = section.querySelector('[data-back-button]');
  const status = section.querySelector('[data-order-status]');
  const variantStatus = section.querySelector('[data-variant-status]');
  const variantInput = section.querySelector('[data-variant-id]');
  const raveStylePanel = section.querySelector('[data-rave-style-panel]');
  const raveStyleTitle = section.querySelector('[data-rave-style-title]');
  const summaryRaveStyleRow = section.querySelector('[data-summary-rave-style-row]');
  const summaryRaveStyle = section.querySelector('[data-summary-rave-style]');
  const designStatus = section.querySelector('[data-design-status]');
  const designSummary = section.querySelector('[data-design-summary]');
  const designPreviewContainer = section.querySelector('[data-design-preview-container]');
  const designPreview = section.querySelector('[data-design-preview]');
  const designPreviewTeam = section.querySelector('[data-design-preview-team]');
  const designPreviewId = section.querySelector('[data-design-preview-id]');
  const designPreviewLink = section.querySelector('[data-design-preview-link]');
  const removeDesignButton = section.querySelector('[data-remove-design]');
  const manualRoster = section.querySelector('[data-manual-roster]');
  const rosterRows = section.querySelector('[data-roster-rows]');
  const rosterCount = section.querySelector('[data-roster-count]');
  const rosterFile = section.querySelector('[data-roster-file]');
  const rosterFilePanel = section.querySelector('[data-roster-file-panel]');
  const rushLabels = {
    standard: 'Standard production',
    rush: 'Priority timing review requested',
  };
  const currencyCode = section.dataset.currencyCode || 'USD';
  const shopifyRoute = (path) => {
    const root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    return `${root.replace(/\/?$/u, '/')}${String(path || '').replace(/^\/+/u, '')}`;
  };
  const sizeOptions = [
    'S',
    'M',
    'L',
    'XL',
    '2XL',
    '3XL',
    '4XL',
    'G-YTH',
    'G-M',
    'G-L',
    'G-XL',
    'G-2XL',
    'YTH-XS',
    'YTH-S',
    'YTH-M',
    'YTH-L',
    'YTH-XL',
  ];
  const captainOptions = ['', 'C', 'A'];
  const state = {
    currentStep: 0,
    quantity: 10,
    style: 'stitched',
    package: 'jersey',
    rosterMode: 'manual',
    rushRequest: 'standard',
    raveStyle: null,
    design: null,
    variantLookup: new Map(),
    selectedEntry: null,
    selectedVariant: null,
  };

  const normalize = (value) =>
    String(value || '')
      .toLowerCase()
      .replace(/&/gu, ' and ')
      .replace(/[^a-z0-9+]+/gu, ' ')
      .trim();

  const normalizeRaveStyleHandle = (value) =>
    String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/gu, '');

  const canonicalStyle = (value) => {
    const text = normalize(value);

    if (text.includes('reversible')) {
      return 'reversible';
    }

    if (text.includes('stitched') || text.includes('embroider') || text.includes('tackle twill')) {
      return 'stitched';
    }

    if (text.includes('printed') || text.includes('sublimat')) {
      return 'printed';
    }

    return text;
  };

  const canonicalPackage = (value) => {
    const text = normalize(value);

    if (text.includes('pant') || text.includes('shell')) {
      return 'jersey-socks-pant';
    }

    if (text.includes('sock')) {
      return 'jersey-socks';
    }

    if (text.includes('jersey')) {
      return 'jersey';
    }

    return text;
  };

  const canonicalTier = (value) => {
    const text = String(value || '');
    const match = text.match(/(?:10-49|50-149|150-299|300-499|500\+)/u);
    return match ? match[0] : normalize(text);
  };

  const normalizeQuantity = (quantity) =>
    Math.max(minQuantity, Math.floor(Number(quantity || minQuantity) || minQuantity));

  const readQuantity = (commitInput) => {
    const count = normalizeQuantity(quantityInput ? quantityInput.value : state.quantity);

    if (commitInput && quantityInput && quantityInput.value !== String(count)) {
      quantityInput.value = String(count);
    }

    return count;
  };

  const resolveTier = (quantity) => {
    const count = normalizeQuantity(quantity);
    const tier = tierRules.find((rule) => count >= rule.min && count <= rule.max);
    return tier ? tier.label : tierRules[0].label;
  };

  const pricingKey = (style, packageKey, tier) => `${style}__${packageKey}__${tier}`;

  const normalizeVariantPriceCents = (value) => {
    const text = String(value ?? '').trim();
    const amount = Number(text);

    if (!Number.isFinite(amount)) {
      return NaN;
    }

    if (typeof value === 'number' || (!text.includes('.') && amount >= 1000)) {
      return Math.round(amount);
    }

    return Math.round(amount * 100);
  };

  const formatMoney = (priceCents) => {
    const amount = Number(priceCents || 0) / 100;

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode,
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2);
    }
  };

  const setText = (element, value) => {
    if (element) {
      element.textContent = value;
    }
  };

  const setProperty = (key, value) => {
    const input = Array.from(section.querySelectorAll('[data-design-property]')).find(
      (field) => field.dataset.designProperty === key,
    );

    if (!input) {
      return;
    }

    const cleanValue = value == null ? '' : String(value).trim();
    input.value = cleanValue;
    input.disabled = cleanValue === '';
  };

  const allowedDesignAssetHosts = new Set([
    'cdn.shopify.com',
    'customize.huinasports.com',
    'huinasports.com',
    'www.huinasports.com',
  ]);
  const allowedDesignLinkHosts = new Set([
    'customize.huinasports.com',
    'huinasports.com',
    'www.huinasports.com',
  ]);
  const allowedImageContentTypes = new Set([
    'image/avif',
    'image/gif',
    'image/jpeg',
    'image/png',
    'image/webp',
  ]);
  const maxDesignUrlLength = 2048;

  const toAbsoluteUrl = (value, base) => {
    const raw = String(value || '').trim();

    if (!raw || raw.length > maxDesignUrlLength) {
      return null;
    }

    try {
      return new URL(raw, base || window.location.origin);
    } catch (error) {
      return null;
    }
  };

  const assetContentType = (asset) => {
    const source = asset && typeof asset === 'object' ? asset : {};
    return String(
      source.contentType || source.content_type || source.mimeType || source.mime_type || '',
    )
      .split(';')[0]
      .trim()
      .toLowerCase();
  };

  const isAllowedUrlHost = (url, allowedHosts) =>
    url.protocol === 'https:' && allowedHosts.has(url.hostname.toLowerCase());

  const isCustomizerCompositePath = (url) =>
    url.hostname.toLowerCase() === 'customize.huinasports.com' &&
    /^\/api\/design\/[^/]+\/composite$/u.test(url.pathname);

  const hasImagePath = (url) => /\.(?:avif|gif|jpe?g|png|webp)$/iu.test(url.pathname);

  const sanitizeDesignAssetUrl = (value, apiBase, asset) => {
    const parsed = toAbsoluteUrl(value, apiBase);

    if (!parsed || !isAllowedUrlHost(parsed, allowedDesignAssetHosts)) {
      return '';
    }

    const contentType = assetContentType(asset);

    if (contentType) {
      return allowedImageContentTypes.has(contentType) ? parsed.href : '';
    }

    return hasImagePath(parsed) || isCustomizerCompositePath(parsed) ? parsed.href : '';
  };

  const sanitizeDesignLinkUrl = (value, base) => {
    const parsed = toAbsoluteUrl(value, base);

    if (!parsed || !isAllowedUrlHost(parsed, allowedDesignLinkHosts)) {
      return '';
    }

    return parsed.href;
  };

  const localizeCustomizerUrl = (value) => {
    const raw = String(value || '').trim();

    if (!raw || !['127.0.0.1', 'localhost'].includes(window.location.hostname)) {
      return raw;
    }

    try {
      const parsed = new URL(raw, window.location.href);

      if (parsed.hostname !== 'customize.huinasports.com') {
        return raw;
      }

      return (
        ['http://', ['127', '0', '0', '1'].join('.'), ':', '3000'].join('') +
        parsed.pathname +
        parsed.search +
        parsed.hash
      );
    } catch (error) {
      return raw;
    }
  };

  const getNested = (source, path) =>
    path.reduce((current, key) => {
      if (!current || typeof current !== 'object') {
        return undefined;
      }

      return current[key];
    }, source);

  const normalizeDesignPayload = (payload, designIdFromUrl, apiBase, customizerUrl) => {
    const source = payload && payload.design ? payload.design : payload || {};
    const fields = source.fields || (payload && payload.fields) || {};
    const links = source.links || {};
    const designId =
      source.id || source.design_id || (payload && payload.design_id) || designIdFromUrl;
    const renderedImageAsset = getNested(source, ['assets', 'renderedImage']);
    const previewFrontAsset = getNested(source, ['assets', 'previewFront']);
    const renderedUrl =
      sanitizeDesignAssetUrl(source.rendered_image, apiBase) ||
      sanitizeDesignAssetUrl(source.composite_url, apiBase) ||
      sanitizeDesignAssetUrl(payload && payload.composite_url, apiBase) ||
      sanitizeDesignAssetUrl(
        getNested(source, ['assets', 'renderedImage', 'url']),
        apiBase,
        renderedImageAsset,
      ) ||
      sanitizeDesignAssetUrl(
        getNested(source, ['assets', 'previewFront', 'url']),
        apiBase,
        previewFrontAsset,
      ) ||
      '';
    const shareUrl =
      source.share_url ||
      (payload && payload.share_url) ||
      links.designUrl ||
      `${String(customizerUrl || '').replace(/\/$/u, '')}/design/${designId}`;

    return {
      id: designId,
      teamName: source.team_name || source.teamName || fields.team_name || fields.teamName || '',
      renderedUrl,
      designUrl: sanitizeDesignLinkUrl(shareUrl, customizerUrl || apiBase),
    };
  };

  const isValidDesignId = (value) =>
    /^(?:HUINA-DESIGN-\d{8}-[A-Z0-9]{8}|design-\d+|[0-9a-f-]{24,})$/u.test(
      String(value || '').trim(),
    );

  const productJsonUrl = (productUrl) => {
    const cleanUrl = String(productUrl || '/products/custom-hockey-jerseys').replace(/\/$/u, '');
    return cleanUrl.endsWith('.js') ? cleanUrl : `${cleanUrl}.js`;
  };

  const fetchProductData = async (productUrl) => {
    const response = await fetch(productJsonUrl(productUrl), {
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) {
      throw new Error(`Product JSON returned ${response.status}`);
    }

    return response.json();
  };

  const fetchDesignSummary = async (apiBase, designId) => {
    const response = await fetch(`${apiBase}/${encodeURIComponent(designId)}`, {
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) {
      throw new Error(`Design API returned ${response.status}`);
    }

    return response.json();
  };

  const buildVariantLookup = (variants) => {
    const lookup = new Map();

    for (const variant of variants || []) {
      const options = Array.isArray(variant.options)
        ? variant.options
        : [variant.option1, variant.option2, variant.option3].filter(Boolean);
      const style = options.map(canonicalStyle).find((option) => styleLabels[option]);
      const packageKey = options
        .map(canonicalPackage)
        .find((option) => Object.prototype.hasOwnProperty.call(packageLabels, option));
      const tier = options.map(canonicalTier).find((option) => pricing.tiers.includes(option));

      if (!style || !packageKey || !tier) {
        continue;
      }

      lookup.set(pricingKey(style, packageKey, tier), variant);
    }

    return lookup;
  };

  const resolveVariant = (entry) => {
    if (!entry) {
      return null;
    }

    if (entry.variantId) {
      return {
        id: entry.variantId,
        price: entry.priceCents,
        options: [entry.styleLabel, entry.packageLabel, entry.tier],
      };
    }

    const variant = state.variantLookup.get(pricingKey(entry.style, entry.package, entry.tier));
    const variantPriceCents = normalizeVariantPriceCents(variant ? variant.price : NaN);

    if (!variant || variantPriceCents !== entry.priceCents) {
      return null;
    }

    return variant;
  };

  const rosterRowValues = () =>
    Array.from(section.querySelectorAll('[data-roster-row]')).map((row) => ({
      name: row.querySelector('[data-player-name]')?.value || '',
      number: row.querySelector('[data-player-number]')?.value || '',
      size: row.querySelector('[data-player-size]')?.value || 'L',
      captain: row.querySelector('[data-player-captain]')?.value || '',
    }));

  const createOption = (value) => {
    const option = document.createElement('option');
    option.value = value;
    option.textContent = value || '-';
    return option;
  };

  const createRosterInput = (type, value, selector, placeholder) => {
    const input = document.createElement('input');
    input.type = type;
    input.value = value || '';
    input.placeholder = placeholder || '';
    input.dataset[selector] = '';
    return input;
  };

  const createRosterSelect = (options, selectedValue, selector) => {
    const select = document.createElement('select');
    select.dataset[selector] = '';
    options.forEach((option) => select.appendChild(createOption(option)));
    select.value = selectedValue || options[0] || '';
    return select;
  };

  const syncRosterRows = () => {
    if (!rosterRows) {
      return;
    }

    const count = readQuantity(false);
    const currentCount = rosterRows.querySelectorAll('[data-roster-row]').length;

    if (currentCount === count) {
      return;
    }

    const existingValues = rosterRowValues();
    rosterRows.innerHTML = '';

    for (let index = 0; index < count; index += 1) {
      const values = existingValues[index] || {};
      const row = document.createElement('div');
      row.className = 'huina-order-flow__roster-row';
      row.dataset.rosterRow = '';
      row.appendChild(createRosterInput('text', values.name, 'playerName', 'Name on back'));
      row.appendChild(createRosterInput('text', values.number, 'playerNumber', '#'));
      row.appendChild(createRosterSelect(sizeOptions, values.size || 'L', 'playerSize'));
      row.appendChild(createRosterSelect(captainOptions, values.captain || '', 'playerCaptain'));
      rosterRows.appendChild(row);
    }
  };

  const manualRosterRows = () =>
    rosterRowValues().filter((row) => row.name.trim() || row.number.trim() || row.captain.trim());

  const manualRosterData = () => {
    const rows = manualRosterRows();

    if (rows.length === 0) {
      return '';
    }

    return [
      'Name on back, Number, Size, Captain',
      ...rows.map((row) =>
        [
          row.name.trim(),
          row.number.trim() ? `#${row.number.trim()}` : '',
          row.size.trim(),
          row.captain.trim(),
        ].join(', '),
      ),
    ].join('\n');
  };

  const rosterSummary = () => {
    if (state.rosterMode === 'file') {
      return rosterFile && rosterFile.files && rosterFile.files[0]
        ? `Roster file: ${rosterFile.files[0].name}`
        : 'Roster file to upload';
    }

    if (state.rosterMode === 'manual') {
      const entered = manualRosterRows().length;
      return `Manual roster: ${entered} / ${state.quantity} entered`;
    }

    return 'Send later';
  };

  const updateRosterVisibility = () => {
    if (manualRoster) {
      manualRoster.hidden = state.rosterMode !== 'manual';
    }

    if (rosterFilePanel) {
      rosterFilePanel.hidden = state.rosterMode !== 'file';
    }

    if (state.rosterMode === 'manual') {
      syncRosterRows();
    }
  };

  const updateRosterCount = () => {
    if (!rosterCount) {
      return;
    }

    const entered = manualRosterRows().length;
    rosterCount.textContent = `${entered} / ${state.quantity} entered`;
  };

  const writeProperties = () => {
    const entry = state.selectedEntry;
    const design = state.design;

    setProperty('design_id', design ? design.id : '');
    setProperty('roster', rosterSummary());
    setProperty('package', entry ? entry.package : state.package);
    setProperty('craft', entry ? entry.style : state.style);
    setProperty('_Design Link', design ? design.designUrl : '');
    setProperty('Team Name', design ? design.teamName : '');
    setProperty('Package', entry ? entry.packageLabel : packageLabels[state.package]);
    setProperty('Craft', entry ? entry.styleLabel : styleLabels[state.style]);
    setProperty('Quantity Tier', entry ? entry.tier : resolveTier(state.quantity));
    setProperty('pricingVersion', pricing ? pricing.pricingVersion : '');
    setProperty('Rendered Preview URL', design ? design.renderedUrl : '');
    setProperty('Rush Request', rushLabels[state.rushRequest] || rushLabels.standard);
    setProperty('Rave Jersey Style', state.raveStyle ? state.raveStyle.label : '');
    setProperty('Roster Data', state.rosterMode === 'manual' ? manualRosterData() : '');
  };

  const selectedEntry = () => {
    if (!pricing || !pricing.entries) {
      return null;
    }

    return (
      pricing.entries[pricingKey(state.style, state.package, resolveTier(state.quantity))] || null
    );
  };

  const entryTitle = (entry) => {
    if (!entry) {
      return `${styleLabels[state.style]} / ${packageLabels[state.package]}`;
    }

    return `${entry.styleLabel} / ${entry.packageLabel}`;
  };

  const updateLivePrice = () => {
    const entry = state.selectedEntry;

    setText(section.querySelector('[data-current-package]'), entryTitle(entry));
    setText(
      section.querySelector('[data-current-tier]'),
      entry ? entry.tier : resolveTier(state.quantity),
    );
    setText(
      section.querySelector('[data-current-unit-price]'),
      entry ? `${formatMoney(entry.priceCents)} each` : 'Unavailable',
    );
    setText(
      section.querySelector('[data-current-total]'),
      entry ? `${formatMoney(entry.priceCents * state.quantity)} total` : 'Unavailable',
    );
  };

  const updateMatrix = () => {
    const tier = resolveTier(state.quantity);

    section.querySelectorAll('[data-package-cell]').forEach((button) => {
      const style = button.dataset.style;
      const packageKey = button.dataset.package;
      const entry =
        pricing && pricing.entries ? pricing.entries[pricingKey(style, packageKey, tier)] : null;
      button.classList.toggle('is-selected', style === state.style && packageKey === state.package);
      button.innerHTML = entry
        ? [
            `<span class="huina-order-flow__cell-package">${entry.packageLabel}</span>`,
            `<strong>${formatMoney(entry.priceCents)}</strong>`,
            `<span>each</span>`,
            `<span>${formatMoney(entry.priceCents * state.quantity)} total</span>`,
          ].join('')
        : '<strong>Unavailable</strong>';
    });
  };

  const updateSummary = (options = {}) => {
    state.quantity = readQuantity(Boolean(options.commitQuantity));
    state.selectedEntry = selectedEntry();
    state.selectedVariant = resolveVariant(state.selectedEntry);
    updateRosterVisibility();
    updateRosterCount();

    setText(section.querySelector('[data-summary-quantity]'), String(state.quantity));
    setText(
      section.querySelector('[data-summary-package]'),
      state.selectedEntry ? state.selectedEntry.packageLabel : packageLabels[state.package],
    );
    setText(
      section.querySelector('[data-summary-style]'),
      state.selectedEntry ? state.selectedEntry.styleLabel : styleLabels[state.style],
    );
    if (summaryRaveStyleRow) {
      summaryRaveStyleRow.hidden = !state.raveStyle;
    }
    setText(summaryRaveStyle, state.raveStyle ? state.raveStyle.label : '');
    setText(
      section.querySelector('[data-summary-unit-price]'),
      state.selectedEntry ? formatMoney(state.selectedEntry.priceCents) : 'Unavailable',
    );
    setText(
      section.querySelector('[data-summary-total]'),
      state.selectedEntry
        ? formatMoney(state.selectedEntry.priceCents * state.quantity)
        : 'Unavailable',
    );
    setText(
      section.querySelector('[data-summary-design]'),
      state.design ? `Design ID: ${state.design.id}` : 'No saved design',
    );
    setText(section.querySelector('[data-summary-roster]'), rosterSummary());
    setText(
      section.querySelector('[data-summary-rush]'),
      rushLabels[state.rushRequest] || rushLabels.standard,
    );

    if (variantInput) {
      variantInput.value = state.selectedVariant ? state.selectedVariant.id : '';
      variantInput.disabled = !state.selectedVariant;
    }

    if (state.selectedVariant) {
      setText(variantStatus, 'Selection ready for cart.');
    } else {
      setText(
        variantStatus,
        'This package is not available for checkout. Contact HUINA for help.',
      );
    }

    writeProperties();
    updateLivePrice();
    updateMatrix();
  };

  const showStep = (step) => {
    state.currentStep = Math.max(0, Math.min(2, step));

    section.querySelectorAll('[data-step-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.stepPanel !== String(state.currentStep);
    });
    section.querySelectorAll('[data-step-label]').forEach((label) => {
      const labelStep = Number(label.dataset.stepLabel);
      label.classList.toggle('is-active', labelStep === state.currentStep);
      label.classList.toggle('is-complete', labelStep < state.currentStep);
      if (labelStep === state.currentStep) {
        label.setAttribute('aria-current', 'step');
      } else {
        label.removeAttribute('aria-current');
      }
    });

    if (backButton) {
      backButton.hidden = state.currentStep === 0;
    }

    if (continueButton) {
      continueButton.textContent = state.currentStep === 2 ? 'Add To Cart' : 'Continue';
      continueButton.disabled = state.currentStep === 2 && !state.selectedVariant;
    }

    updateSummary();
  };

  const setDesign = (design) => {
    state.design = design;

    if (!design) {
      if (designPreviewContainer) {
        designPreviewContainer.hidden = true;
      }
      if (designPreview) {
        designPreview.hidden = true;
        designPreview.removeAttribute('src');
      }
      setText(designPreviewTeam, '');
      setText(designPreviewId, '');
      if (designPreviewLink) {
        designPreviewLink.removeAttribute('href');
      }
      setText(
        designStatus,
        'No saved design loaded. Use the customizer first, or continue with roster and package details.',
      );
      setText(designSummary, '');
      updateSummary();
      return;
    }

    setText(designStatus, 'Saved design connected. Confirm package and roster before cart.');
    setText(designPreviewTeam, design.teamName ? `Team: ${design.teamName}` : 'Team: Not provided');
    setText(designPreviewId, `Design ID: ${design.id}`);
    if (designPreviewLink) {
      if (design.designUrl) {
        designPreviewLink.href = design.designUrl;
      } else {
        designPreviewLink.removeAttribute('href');
      }
    }
    setText(
      designSummary,
      [design.teamName ? `Team: ${design.teamName}` : '', `Design ID: ${design.id}`]
        .filter(Boolean)
        .join(' · '),
    );

    if (design.renderedUrl && designPreviewContainer && designPreview) {
      designPreview.src = design.renderedUrl;
      designPreview.hidden = false;
      designPreviewContainer.hidden = false;
    } else if (designPreviewContainer && designPreview) {
      designPreview.hidden = true;
      designPreview.removeAttribute('src');
      designPreviewContainer.hidden = true;
    }

    updateSummary();
  };

  const loadDesign = async () => {
    const params = new URLSearchParams(window.location.search);
    const designId = String(params.get('design_id') || '').trim();

    if (!designId) {
      return;
    }

    if (!isValidDesignId(designId)) {
      setText(designStatus, 'Invalid saved-design link. Open the customizer again or continue without a saved design.');
      updateSummary();
      return;
    }

    try {
      const apiBase = localizeCustomizerUrl(section.dataset.customizerApiUrl).replace(/\/$/u, '');
      const customizerUrl = localizeCustomizerUrl(section.dataset.customizerUrl);
      const payload = await fetchDesignSummary(apiBase, designId);
      setDesign(normalizeDesignPayload(payload, designId, apiBase, customizerUrl));
    } catch (error) {
      const customizerUrl = localizeCustomizerUrl(section.dataset.customizerUrl);
      setDesign({
        id: designId,
        teamName: '',
        renderedUrl: '',
        designUrl: sanitizeDesignLinkUrl(
          `${String(customizerUrl || '').replace(/\/$/u, '')}/design/${designId}`,
          customizerUrl,
        ),
      });
      setText(designStatus, 'Saved design link received. Confirm package and roster before cart.');
    }
  };

  const loadRaveStyle = () => {
    const params = new URLSearchParams(window.location.search);
    const handle = normalizeRaveStyleHandle(params.get('rave_style'));
    const label = raveStyleLabels[handle];

    if (!label) {
      return;
    }

    state.raveStyle = { handle, label };

    if (raveStylePanel) {
      raveStylePanel.hidden = false;
    }
    setText(raveStyleTitle, label);
  };

  const loadVariants = async () => {
    try {
      const product = await fetchProductData(section.dataset.productUrl);
      state.variantLookup = buildVariantLookup(product.variants || []);
      setText(status, '');
    } catch (error) {
      state.variantLookup = new Map();
      setText(status, 'Product options are temporarily unavailable. Please try again or contact HUINA.');
    }

    updateSummary();
  };

  if (!pricing || !pricing.entries) {
    setText(status, 'Pricing is temporarily unavailable. Please contact HUINA.');
    if (continueButton) {
      continueButton.disabled = true;
    }
    return;
  }

  section.querySelectorAll('[data-package-cell]').forEach((button) => {
    button.addEventListener('click', () => {
      state.style = button.dataset.style || state.style;
      state.package = button.dataset.package || state.package;
      updateSummary();
    });
  });

  section.querySelectorAll('[data-roster-mode]').forEach((button) => {
    button.classList.toggle('is-selected', button.dataset.rosterMode === state.rosterMode);
    button.addEventListener('click', () => {
      state.rosterMode = button.dataset.rosterMode || 'later';
      section.querySelectorAll('[data-roster-mode]').forEach((item) => {
        item.classList.toggle('is-selected', item === button);
      });
      updateSummary();
    });
  });

  section.querySelectorAll('[data-rush-option]').forEach((field) => {
    field.addEventListener('change', () => {
      if (field.checked) {
        section.querySelectorAll('[data-rush-option]').forEach((item) => {
          item.checked = item === field;
        });
        state.rushRequest = field.value === 'rush' ? 'rush' : 'standard';
        updateSummary();
      }
    });
  });

  [quantityInput, rosterFile].forEach((field) => {
    if (field) {
      field.addEventListener('input', updateSummary);
      field.addEventListener('keyup', updateSummary);
      field.addEventListener('change', () =>
        updateSummary({ commitQuantity: field === quantityInput }),
      );
      field.addEventListener('blur', () =>
        updateSummary({ commitQuantity: field === quantityInput }),
      );
    }
  });

  if (rosterRows) {
    rosterRows.addEventListener('input', updateSummary);
    rosterRows.addEventListener('change', updateSummary);
  }

  if (removeDesignButton) {
    removeDesignButton.addEventListener('click', () => {
      setDesign(null);
    });
  }

  section.querySelectorAll('[data-step-label]').forEach((label) => {
    label.addEventListener('click', () => {
      const step = Number(label.dataset.stepLabel);

      if (Number.isFinite(step)) {
        showStep(step);
      }
    });
  });

  if (backButton) {
    backButton.addEventListener('click', () => showStep(state.currentStep - 1));
  }

  if (continueButton) {
    continueButton.addEventListener('click', async () => {
      if (state.currentStep < 2) {
        showStep(state.currentStep + 1);
        return;
      }

      if (!state.selectedVariant || !form) {
        setText(
          status,
          'This package is not available for checkout. Please choose another option or contact HUINA.',
        );
        return;
      }

      continueButton.disabled = true;
      setText(status, 'Adding configured order to cart.');

      try {
        const response = await fetch(shopifyRoute('cart/add.js'), {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });

        if (!response.ok) {
          throw new Error(`Cart add returned ${response.status}`);
        }

        setText(status, 'Added to cart. Opening cart.');
        window.location.assign(shopifyRoute('cart'));
      } catch (error) {
        setText(status, 'We could not add this order to the cart. Please try again or contact HUINA.');
      } finally {
        continueButton.disabled = !state.selectedVariant;
      }
    });
  }

  loadRaveStyle();
  showStep(0);
  loadVariants();
  loadDesign();
})();
